import {defineStore} from "pinia";
import useSharedMethod from "@/use/SharedMethod";
import axios from "axios";

export const useFolderStore = defineStore('folder', {
    state: () => ({
        folder: {},
        folders: [],
        loading: false,
    }),
    actions: {
        setLoading(state, loading) {
            state.loading = loading
        },
        setFolder(folder) {
            this.folder = folder
        },
        setFolders(folders) {
            this.folders = folders
        },
        addFolder(folder) {
            this.folders.unshift(folder)
        },
        updateFolder(folder) {
            let index = this.folders.findIndex(cl => cl.id === folder.id)
            this.folders.splice(index, 1, folder)
        },
        deleteFolder(folder) {
            let index = this.folders.findIndex(cl => cl.id === folder.id)
            this.folders.splice(index, 1)
        },
        findAll() {
            this.loading = true;
            const {transformFilterValues} = useSharedMethod();
            axios.get('/folders', {params: transformFilterValues({allRecords: true})}).then(response => {
                this.folders = response.data;
            }).finally(() => {
                this.loading = false;
            });
        },
    },
});